import script from "./WelcomeCard.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomeCard.vue?vue&type=script&setup=true&lang=js"

import "./WelcomeCard.vue?vue&type=style&index=0&id=d81fd4ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d81fd4ac"]])

export default __exports__